import React, { useEffect, useState } from 'react';
import { ProfileSection, ProfileSectionTitle } from '../Global/profileStyles';
import { batch, shallowEqual } from 'react-redux';
import { IonRange } from '@ionic/react';
import {
	UPDATE_PREFS_MAX_DIFFICULTY,
	UPDATE_PREFS_MIN_DIFFICULTY,
} from '../../state/prefsSlice';
import { useAppDispatch, useAppSelector } from '../../state/hooks';
import { RootState } from '../../state/store';
import { difficulties } from '../../models/helpers/Helpers';

const Range = () => {
	const dispatch = useAppDispatch();
	const user_prefs = useAppSelector(
		(state: RootState) => state.prefs,
		shallowEqual,
	);

	type RangeValue = number | { lower: number; upper: number };
	const [difficulty, setDifficulty] = useState<RangeValue>({
		lower: user_prefs.min_difficulty,
		upper: user_prefs.max_difficulty,
	});

	const handleChangeDifficulty = (e: CustomEvent) => {
		batch(() => {
			dispatch({
				type: UPDATE_PREFS_MIN_DIFFICULTY,
				payload: {
					min_difficulty: e.detail.value.lower,
				},
			});
			dispatch({
				type: UPDATE_PREFS_MAX_DIFFICULTY,
				payload: {
					max_difficulty: e.detail.value.upper,
				},
			});
		});
		setDifficulty({
			lower: e.detail.value.lower,
			upper: e.detail.value.upper,
		});
	};

	useEffect(() => {
		setDifficulty({
			lower: user_prefs.min_difficulty,
			upper: user_prefs.max_difficulty,
		});
	}, []);

	return (
		<ProfileSection>
			<ProfileSectionTitle>Difficulty</ProfileSectionTitle>
			<p className="description">Set your preferred difficulty...</p>
			<IonRange
				aria-label="Difficulty Range"
				dualKnobs={true}
				value={difficulty}
				ticks={true}
				snaps={true}
				min={1}
				max={5}
				onIonChange={(e) => {
					handleChangeDifficulty(e);
				}}
			/>
			<p>{`${difficulties[user_prefs.min_difficulty - 1]} — ${
				difficulties[user_prefs.max_difficulty - 1]
			}`}</p>
		</ProfileSection>
	);
};

export default Range;
